export default __webpack_public_path__ + "static/media/darosoft.19f2e0a7.png";